import React, { useContext, useEffect, useState } from 'react'
import { getRolesforPersonnel, getPermissionGroups, assignRole, removeRole } from '../../../../actions/personnel/personnel'
import { useDispatch, useSelector } from 'react-redux'
import { StaffRosterContext } from '../../../../utils/context'
import Table from '../../../../components/Table'
import Button from '../../../../components/Button'
import EnrollModal from './EnrollModal/EnrollModal'
import Confirmation from '../../../../components/Confirmation/Confirmation'
import { BiTrash } from 'react-icons/bi'
import styles from '../styles.module.css'


export default function Role() {
  const { allForms, addMode, mid: contextMid } = useContext(StaffRosterContext)
  const { personnelRolesList, personnelAllRolesList } = useSelector(state => state.personnel)
  const { permissionGroups } = useSelector(state => state.permissions || {})
  console.log('permissionGroups::: ', permissionGroups);

  const { values } = allForms
  const mid = contextMid || values?.mid
  const dispatch = useDispatch()

  const [openEnrollModal, setOpenEnrollModal] = useState(false)
  const [confirmation, setConfirmation] = useState(false)
  const [allRoles, setAllRoles] = useState([])

  useEffect(() => {
    if (mid && !addMode) {
      dispatch(getRolesforPersonnel(mid))
    }
    dispatch(getPermissionGroups())
  }, [mid, addMode, dispatch])

  // Получаем список всех ролей из Redux или загружаем отдельно
  useEffect(() => {
    if (permissionGroups) {
      setAllRoles(personnelAllRolesList)
    }
  }, [personnelAllRolesList])

  const handleAssignRole = async (groupId) => {
    if (mid && groupId) {
      await dispatch(assignRole(groupId, mid))
      setOpenEnrollModal(false)
    }
  }

  const handleRemoveRole = async () => {
    if (confirmation?.groupId && mid) {
      await dispatch(removeRole(confirmation.groupId, mid))
      setConfirmation(false)
    }
  }

  const renderRow = (row) => {
    const { name, id, group_id } = row || {}
    const groupId = id || group_id
    return (
      <tr key={groupId}>
        <td>{name}</td>
        <td>
          <i
            className={styles.trash}
            onClick={() => setConfirmation({ groupId, name })}
          >
            <BiTrash />
          </i>
        </td>
      </tr>
    )
  }
  console.log('openEnrollModal::: ', openEnrollModal);
  console.log('personnelRolesList::: ', personnelRolesList);
  console.log('personnelAllRolesList::: ', personnelAllRolesList);

  const openEnroll = () => {
    setOpenEnrollModal(true)
  }

  const closeEnroll = () => {
    setOpenEnrollModal(false)
  }

  return (
    <div className={styles.tabWrapper}>
      {openEnrollModal &&
        <EnrollModal
          closeModal={closeEnroll}
          allRoles={personnelAllRolesList}
          currentRoles={personnelRolesList}
          onAssignRole={handleAssignRole}
        />
      }

      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить роль "${confirmation.name}"?`}
          acceptConfirmation={handleRemoveRole}
          rejectConfirmation={() => setConfirmation(false)}
        />
      )}

      <div className={styles.qualificationTableSection}>
        <Table>
          <thead>
            <tr>
              <th>Роль</th>
              <th style={{ width: '60px' }}>Удалить</th>
            </tr>
          </thead>
          <tbody>
            {personnelRolesList?.length > 0 ? (
              personnelRolesList.map(renderRow)
            ) : (
              <tr>
                <td colSpan="2" className={styles.emptyTable}>
                  Нет назначенных ролей
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <div className={styles.qualificationForm}>
        <div className={styles.inputsRow}>
          <div className={styles.qualificationButtonsInline}>
            <Button onClick={openEnroll}>+ Добавить роль</Button>
          </div>
        </div>
      </div>
    </div>
  )
}
